import { Box, BoxProps } from '@chakra-ui/react';

interface FormWrapperProps extends BoxProps {
  children: React.ReactNode;
}

export const FormWrapper = ({ children, ...props }: FormWrapperProps) => {
  return (
    <Box
      p={6}
      borderRadius="lg"
      bg="white"
      border="1px solid"
      borderColor="gray.100"
      _hover={{
        borderColor: "blue.200",
        boxShadow: "0 0 0 1px var(--chakra-colors-blue-200)",
      }}
      {...props}
    >
      {children}
    </Box>
  );
}; 